// extracted by mini-css-extract-plugin
module.exports = {"container":"Collects_container__tIkuL"};